'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ProductsConfig = exports.ProductsConfig = function ProductsConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('app.product', {
    url: '^/products/:product',
    template: '<product-materials></product-materials>',
    resolve: {
      materials: function materials(data, ProductsDataProvider, $stateParams) {
        "ngInject";

        return ProductsDataProvider.loadProductMaterials($stateParams.product);
      }
    }
  });

  $stateProvider.state('app.product.material', {
    url: '^/products/:product/:material',
    template: '<material-mode> </material-mode>',
    resolve: {
      spec: function spec(materials, ProductsDataProvider, $stateParams) {
        "ngInject";

        var product = $stateParams.product,
            material = $stateParams.material;

        return ProductsDataProvider.loadProductMaterialsSpec(product, material);
      },
      pricing: function pricing(materials, ProductsDataProvider, $stateParams) {
        var product = $stateParams.product,
            material = $stateParams.material;

        return ProductsDataProvider.loadProductMaterialPricing(product, material);
      }
    }
  });

  $stateProvider.state('app.product.material.spec', {
    url: '^/products/:product/:material/spec',
    template: '<product-material-spec> </product-material-spec>'
  });

  $stateProvider.state('app.product.material.pricing', {
    url: '^/products/:product/:material/pricing',
    template: '<product-material-pricing> </product-material-pricing>'
  });
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/config.js
 **/